import { lazy, Suspense } from "react";
import { Seo } from "@/components/Seo";
import { SITE } from "@/data/site";
import { Hero, Marquee } from "@/components/home/Hero";
import { productSchema } from "@/components/ProductCard";
import { useProducts } from "@/lib/products";

const HomeBelow = lazy(() => import("@/components/home/Below"));

const webSite = { "@type": "WebSite", "@id": `${SITE.url}/#website`, url: SITE.url, name: SITE.name, publisher: { "@id": `${SITE.url}/#business` } };

export default function Home() {
  const products = useProducts({ featured: true }) || [];
  return (
    <>
      <Seo
        title="Wholesale LVP Flooring | 40–50% Less Than Big Box | Cornelius & Lake Norman, NC"
        description="Quality luxury vinyl plank (LVP) for 40–50% less than big-box store pricing. Professional installation and contractor supply in Huntersville, Cornelius, Denver, Sherrills Ford and Iron Station."
        path="/"
        schema={[webSite, productSchema(products, SITE.url)]}
      />
      <Hero />
      <Marquee />
      <Suspense fallback={<div className="min-h-screen" />}>
        <HomeBelow />
      </Suspense>
    </>
  );
}
